export const embeddedWeb = {
  container:
    'bg-[var(--host-surface)] text-[var(--host-text)] rounded-[8px] border border-[var(--host-border)] overflow-hidden mb-3',
  header: 'px-3 py-2.5 border-b border-[var(--host-border)]',
  headerRow: 'flex flex-col sm:flex-row sm:items-start sm:justify-between gap-2',
  title: 'text-[14px] leading-5 font-semibold text-[var(--host-text)]',
  description: 'mt-0.5 text-[13px] leading-[19px] text-[var(--host-text-secondary)]',
  searchWrap: 'relative w-full sm:w-52',
  searchIcon: 'absolute left-2.5 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-[var(--host-text-secondary)]',
  input:
    'w-full min-h-[40px] pl-8 pr-3 py-2 text-[14px] leading-5 bg-[var(--host-surface)] text-[var(--host-text)] border border-[var(--host-border)] rounded-[8px] focus:outline-none focus:ring-2 focus:ring-[var(--host-focus-ring)] focus:border-[var(--host-primary)]',
  statusPill:
    'shrink-0 rounded-[8px] border border-[var(--host-border)] px-2 py-1 text-[12px] leading-4 font-medium text-[var(--host-text-secondary)]',
  empty: 'p-4 text-center',
  emptyTitle: 'text-[14px] leading-5 font-medium text-[var(--host-text)]',
  emptyText: 'mt-1 text-[13px] leading-[19px] text-[var(--host-text-secondary)]',
} as const;

export const embeddedTableWeb = {
  toolbar: 'flex items-center gap-2',
  searchWrap: 'relative flex-1 sm:flex-initial sm:w-52',
  desktopWrap: 'hidden md:block overflow-x-auto',
  head: 'bg-[var(--bg-elevated)] border-b border-[var(--host-border)]',
  th: 'px-3 py-2 text-left text-[12px] leading-4 font-semibold text-[var(--host-text-secondary)]',
  thAction: 'px-3 py-2 text-right text-[12px] leading-4 font-semibold text-[var(--host-text-secondary)]',
  thInner: 'flex items-center gap-1.5',
  body: 'bg-[var(--host-surface)] divide-y divide-[var(--host-border)]',
  row: 'transition-colors',
  rowClickable: 'cursor-pointer hover:bg-primary-50',
  td: 'px-3 py-2.5 text-[14px] leading-5 text-[var(--host-text)] whitespace-nowrap',
  actionCell: 'px-3 py-2.5 text-right text-[13px]',
  actionWrap: 'flex items-center justify-end gap-1.5',
  actionButton:
    'min-h-[36px] px-3 py-1.5 rounded-[8px] text-[13px] font-medium transition-colors',
  mobileWrap: 'md:hidden divide-y divide-[var(--host-border)]',
  mobileRow: 'px-3 py-2.5 space-y-2',
  mobileField: 'flex justify-between items-start gap-3',
  mobileLabel: 'text-[12px] leading-4 font-medium text-[var(--host-text-secondary)]',
  mobileValue: 'text-[14px] leading-5 text-[var(--host-text)] text-right flex-1 break-words',
  mobileActions: 'flex items-center gap-1.5 pt-2 border-t border-[var(--host-border)]',
  mobileActionButton:
    'flex-1 min-h-[40px] py-2 px-2.5 rounded-[8px] text-[13px] font-medium transition-colors touch-manipulation',
  pagination: 'px-3 py-2.5 border-t border-[var(--host-border)] bg-[var(--bg-elevated)]',
  paginationInner: 'flex flex-col sm:flex-row items-center justify-between gap-2',
  paginationText: 'text-[13px] leading-5 text-[var(--host-text-secondary)]',
  paginationControls: 'flex items-center gap-1.5',
  paginationButton:
    'p-1.5 rounded-[8px] hover:bg-primary-50 disabled:opacity-50 disabled:cursor-not-allowed min-w-[36px] min-h-[36px] touch-manipulation',
  exportButton:
    'flex items-center gap-1.5 px-3 py-2 text-[13px] font-medium text-primary-700 bg-primary-50 border border-primary-100 rounded-[8px] hover:bg-primary-100 transition-colors min-h-[38px] touch-manipulation',
  sortIcon: 'text-[var(--host-text-secondary)]',
  sortPlaceholder: 'w-3.5 h-3.5',
  actionDanger: 'bg-red-50 text-red-700 hover:bg-red-100 disabled:opacity-50',
  actionSuccess: 'bg-green-50 text-green-700 hover:bg-green-100 disabled:opacity-50',
  actionDefault: 'bg-[var(--bg-elevated)] text-[var(--host-text)] hover:bg-primary-50 disabled:opacity-50',
  mobileActionDanger: 'bg-red-50 text-red-700 active:bg-red-100 disabled:opacity-50',
  mobileActionSuccess: 'bg-green-50 text-green-700 active:bg-green-100 disabled:opacity-50',
  mobileActionDefault:
    'bg-[var(--bg-elevated)] text-[var(--host-text)] active:bg-primary-50 disabled:opacity-50',
  pageCurrentText: 'text-[13px] leading-5 text-[var(--host-text-secondary)] px-1.5',
  defaultPageSize: 5,
} as const;

export const embeddedListWeb = {
  itemWrap: 'divide-y divide-[var(--host-border)]',
  item: 'px-3 py-2.5',
  itemTop: 'flex items-start justify-between gap-2',
  itemBody: 'min-w-0 flex-1',
  itemTitle: 'text-[14px] leading-5 font-semibold text-[var(--host-text)]',
  itemSubtitle: 'mt-0.5 text-[13px] leading-[19px] text-[var(--host-text-secondary)]',
  itemDescription: 'mt-1.5 text-[13px] leading-[19px] text-[var(--host-text)]',
  meta: 'mt-2 grid grid-cols-1 sm:grid-cols-2 gap-x-3 gap-y-1',
  metaRow: 'flex justify-between gap-2 text-[13px] leading-[19px]',
  metaKey: 'text-[var(--host-text-secondary)]',
  metaValue: 'text-right text-[var(--host-text)]',
} as const;

export const embeddedChartDesign = {
  containerMarginTop: 6,
  containerMarginHorizontal: 2,
  containerPadding: 8,
  containerRadius: 8,
  borderColor: 'rgba(101, 115, 110, 0.22)',
  titleFontSize: 14,
  titleLineHeight: 20,
  titleMarginBottom: 2,
  chartMinWidth: 240,
  chartMaxWidth: 330,
  chartViewportGutter: 70,
  chartHeight: 184,
  pieHeight: 184,
  chartPadding: { top: 10, bottom: 34, left: 36, right: 12 },
  piePadding: { top: 10, bottom: 10, left: 10, right: 10 },
  pieInnerRadius: 28,
  axisFontSize: 8,
  xAxisFontSize: 8,
  axisPadding: 4,
  xTickAngleThreshold: 4,
  xTickAngle: -24,
  lineStrokeWidth: 1.1,
  areaStrokeWidth: 1,
  chartPrimaryColor: '#2563eb',
  chartColorScale: ['#2563eb', '#16a34a', '#f59e0b', '#dc2626', '#7c3aed'],
  gridStroke: '#e5e7eb',
  containerBackgroundColor: '#fff',
  titleColor: '#1f2937',
  summaryBackgroundColor: '#f8fafc',
  summaryTextColor: '#4b5563',
  emptyTextColor: '#6b7280',
  summaryMarginTop: 2,
  summaryPadding: 5,
  summaryRadius: 8,
  summaryGap: 5,
  summaryTextFontSize: 12,
  summaryTextLineHeight: 17,
  emptyFontSize: 13,
  emptyLineHeight: 19,
} as const;

export const embeddedFormDesign = {
  containerRadius: 8,
  containerPadding: 10,
  containerGap: 10,
  borderColor: 'rgba(101, 115, 110, 0.22)',
  headerGap: 3,
  titleFontSize: 14,
  titleLineHeight: 20,
  descriptionFontSize: 13,
  descriptionLineHeight: 19,
  fieldsGap: 10,
  submitErrorRadius: 8,
  submitErrorPaddingHorizontal: 10,
  submitErrorPaddingVertical: 8,
  submitErrorFontSize: 13,
  submitErrorLineHeight: 19,
} as const;
